<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon class="bright" points="4,3 4,1 1,3.5 4,6 4,4 12,4 12,3" />
	<polygon class="bright" points="0,1 0,6 1,6 1,3.5 1,1" />
	<polygon class="bright" points="8,8 0,8 0,9 8,9 8,11 11,8.5 8,6" />
	<polygon class="bright" points="11,8.5 11,11 12,11 12,6 11,6" />
</svg>
</template>